import React, { useEffect } from "react";
import md5 from "md5";
console.log('enter-home----')
function Home (props) {
  const { search } = props.location;
  const location = window.location;
  console.log(location);
  console.log("params", search);
  // let domain = ''
  // if(window.location.host.includes(":")){
  //   domain = window.location.protocol + '//' + window.location.host.split(":")[0]
  // } else {
  //   domain = window.location.protocol + '//' + window.location.host
  // }
  let domain = 'https://www.bm250.com' //window.location.protocol + "//" + window.location.host;
  console.log(domain);
  const ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";

  function base58Decode (str) {
    let zeros = 0;
    while (zeros < str.length && str[zeros] === "1") zeros++;
    const bytes = []; // base-256 digits, least significant first
    for (const ch of str) {
      let carry = ALPHABET.indexOf(ch);
      if (carry < 0) throw new Error(`Invalid Base58 character: ${ch}`);
      for (let j = 0; j < bytes.length; j++) {
        carry += bytes[j] * 58;
        bytes[j] = carry & 0xff;
        carry >>= 8;
      }
      while (carry > 0) {
        bytes.push(carry & 0xff);
        carry >>= 8;
      }
    }
    return Uint8Array.from([...new Array(zeros).fill(0), ...bytes.reverse()]);
  }
  // 这是 gcm.js 的内容
  function hexToUint8 (hexString) {
    if (!hexString || typeof hexString !== 'string')
      return new Uint8Array(0)
    return new Uint8Array((hexString.match(/.{1,2}/g) || []).map(byte => parseInt(byte, 16)))
  }

  // 辅助：Base64 转 Uint8Array
  function base64ToUint8 (base64) {
    if (!base64 || typeof base64 !== 'string')
      return new Uint8Array(0);

    // 1. 定义 Base64 字符映射表
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    const lookup = new Uint8Array(256);
    for (let i = 0; i < chars.length; i++) {
      lookup[chars.charCodeAt(i)] = i;
    }

    // 2. 清理所有非 Base64 字符（自动过滤换行、空格、引号、URL转义字符等）
    let clean = base64.replace(/ /g, '+').replace(/-/g, '+').replace(/_/g, '/');
    clean = clean.replace(/[^A-Za-z0-9+/]/g, '');
    // 剔除所有非法字符后补齐 '=' 填充，保证 4 字符对齐（否则末组会解错）
    clean = clean.padEnd(Math.ceil(clean.length / 4) * 4, '=');

    // 3. 手动按位解码（绕过 atob 的严格限制）
    const len = clean.length;
    const bufLen = Math.floor((len * 3) / 4);
    const bytes = new Uint8Array(bufLen);

    let p = 0;
    for (let i = 0; i < len; i += 4) {
      const encoded1 = lookup[clean.charCodeAt(i)];
      const encoded2 = lookup[clean.charCodeAt(i + 1)];
      const encoded3 = lookup[clean.charCodeAt(i + 2)];
      const encoded4 = lookup[clean.charCodeAt(i + 3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      if (i + 2 < len && clean[i + 2] !== '=') {
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      }
      if (i + 3 < len && clean[i + 3] !== '=') {
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
      }
    }

    return bytes.subarray(0, p);
  }
  async function decryptBackendData (cipherBase64, keyStr) {
    // 1. 处理 Key：如果是 32 位 HEX 字符串，需解析为 16 字节
    let keyData
    if (/^[0-9a-fA-F]{32}$/.test(keyStr)) {
      keyData = hexToUint8(keyStr)
    } else {
      keyData = new TextEncoder().encode(keyStr)
    }

    const cryptoKey = await window.crypto.subtle.importKey('raw', keyData, {
      name: 'AES-GCM'
    }, false, ['decrypt'])

    // 2. 将 Base64 解码成完整的字节数组
    const fullBytes = base64ToUint8(cipherBase64)

    // 3. 诊断模式：自动尝试常见布局（IV 在前/后 × 12/16 字节 × tag 96/128 bit）
    const layouts = [
      { name: 'IV前12 + tag128', iv: fullBytes.slice(0, 12), cipher: fullBytes.slice(12), tagLength: 128 },
      { name: 'IV前16 + tag128', iv: fullBytes.slice(0, 16), cipher: fullBytes.slice(16), tagLength: 128 },
      { name: 'IV前12 + tag96',  iv: fullBytes.slice(0, 12), cipher: fullBytes.slice(12), tagLength: 96 },
      { name: 'IV前16 + tag96',  iv: fullBytes.slice(0, 16), cipher: fullBytes.slice(16), tagLength: 96 },
      { name: 'IV尾12 + tag128', iv: fullBytes.slice(-12),  cipher: fullBytes.slice(0, -12), tagLength: 128 },
      { name: 'IV尾16 + tag128', iv: fullBytes.slice(-16),  cipher: fullBytes.slice(0, -16), tagLength: 128 },
      { name: 'IV尾12 + tag96',  iv: fullBytes.slice(-12),  cipher: fullBytes.slice(0, -12), tagLength: 96 },
      { name: 'IV尾16 + tag96',  iv: fullBytes.slice(-16),  cipher: fullBytes.slice(0, -16), tagLength: 96 }
    ]

    for (const layout of layouts) {
      try {
        const decryptedBuffer = await window.crypto.subtle.decrypt({
          name: 'AES-GCM',
          iv: layout.iv,
          tagLength: layout.tagLength
        }, cryptoKey, layout.cipher)
        const text = new TextDecoder().decode(decryptedBuffer)
        console.log('GCM 解密成功，布局命中:', layout.name)
        return text
      } catch (e) {
        // 该布局失败，继续尝试下一种
      }
    }

    // 4. 全部布局都失败：打印数据形态便于定位
    const head12 = fullBytes.slice(0, 12)
    const tail12 = fullBytes.slice(-12)
    console.warn('GCM 8 种布局全部尝试失败，数据形态:', {
      total: fullBytes.length,
      head12Hex: Array.from(head12).map(b => b.toString(16).padStart(2, '0')).join(''),
      tail12Hex: Array.from(tail12).map(b => b.toString(16).padStart(2, '0')).join('')
    })
    throw new Error('AES-GCM 解密失败（已尝试 8 种常见布局）')
  }

  const decriptData = async (token, content) => {
    if (!content)
      return {}
    if (typeof (content) === 'object')
      return content
    const flag = content.startsWith('[[')
    if (flag)
      return JSON.parse(content)

    let keySource = content.substring(0, 21)
    keySource = Uint8ArrayToString(base58Decode(keySource))
    const cipherText = content.substring(21, content.length)

    const tsStr = keySource.substring(0, 13)
    const indexStr = keySource.substring(13, keySource.length)
    const ts = parseInt(tsStr)
    const index = parseInt(indexStr)
    if (!Number.isFinite(ts) || !Number.isFinite(index) || index < 0 || index > 16) {
      console.warn('decriptData: ts/index 解析异常', { keySource, tsStr, indexStr })
      return []
    }
    // 用原始 ts 字符串拼接，避免 parseInt 吞掉前导零
    const source = md5(md5(tsStr + token))
    const aesKey = token.substring(index, index + 16)
    console.log({token,content,ts, index, source, aesKey,keySource})

    let rawResStr = ''
    try {
      // 优先使用 GCM 解密 (已内部支持从密文中自动提取前 12 字节 IV)
      rawResStr = await decryptBackendData(cipherText, aesKey)
      console.log(token,content,ts, index, source, aesKey, '优先使用 GCM 解密', rawResStr)
    } catch (gcmError) {
      console.warn('GCM 解密失败', gcmError)
      return []

    }

    try {
      return JSON.parse(rawResStr)
    } catch (e) {
      return rawResStr
    }
  }
  async function getApi (token) {
    const url = domain + "/check";
    //const url = "https://wwww.1111wdty.com/check";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: "token=" + token,
    });
    const json = await response.json();
    return json;
  }
  async function domainStat (did) {
    const url = domain + "/stat/domain";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: "did=" + did,
    });
    const json = await response.json();
    return json;
  }
  function Uint8ArrayToString (fileData) {
    var dataString = "";
    for (var i = 0; i < fileData.length; i++) {
      dataString += String.fromCharCode(fileData[i]);
    }

    return dataString;
  }

  function getSpeedWithImg (imgUrl, fileSize) {
    return new Promise((resolve, reject) => {
      let start = null;
      let end = null;
      let img = document.createElement("img");
      start = new Date().getTime();
      img.onload = function (e) {
        end = new Date().getTime();
        const speed = (fileSize * 1000) / (end - start);
        resolve(speed);
      };
      img.onerror = function (e) {
        resolve(10000000)
      }
      img.src = imgUrl;
    }).catch((err) => {
      throw err;
    });
  }
  const cb = (arr) => {
    console.log(arr);
    const min = Math.min.apply(
      null,
      arr.map((item) => {
        console.log(item);
        return item.speed;
      })
    );
    console.log("min", min);
    const minItem = arr.find((item) => item.speed === min);
    console.log(minItem);
    domainStat(minItem.id)
    window.location.href = minItem.domain + search;
  };
  useEffect(() => {
    const token = md5(md5(new Date().getTime()));
    getApi(token).then(async (res) => {
      console.log("getApi", res,token);

      const data = res.data;
      // 传入完整的 data：前 21 字符是 base58 编码的 (ts+index)，其余是 GCM 密文
      const siteArr = await decriptData(token, data);
      console.log("siteArr", siteArr);
      if (!Array.isArray(siteArr)) {
        console.warn("decriptData 未返回站点数组", siteArr);
        return;
      }
      // const siteArr = [
      //   { domain: "https://www.wd88.bet/#/" },
      //   { domain: "https://www.123.bet/#/" },
      // ];
      const arr = [];
      siteArr.forEach((ele, index) => {
        //判断域名结尾
        //域名结尾是 /#/ 替换成空
        //域名结尾是 / 替换成空
        const _domain = ele.domain.includes("/#/")
          ? ele.domain.replace("/#/", "")
          : ele.domain.endsWith("/")
            ? ele.domain.substring(0, ele.domain.length - 1)
            : ele.domain;
        //console.log(_domain + "/image/spacer.png");
        getSpeedWithImg(_domain + "/image/spacer.png", 0.095).then((speed) => {
          console.log("speed", speed);
          arr.push({
            id: ele.id,
            domain: ele.domain,
            speed,
          });
          console.log(arr, siteArr);
          if (arr.length === siteArr.length) {
            cb(arr);
          }
        });
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}

export default Home;
